export const environment = {
  production: false,
  firebase: {
    projectId: "join-abea3",
    appId: "1:283248561390:web:b65efece017763c535f7ff",
    storageBucket: "join-abea3.firebaseapp.com",
    apiKey: "AIzaSyBN55FsWxEj-roPKrwvloY9ofFA2mJDz-E",
    authDomain: "join-abea3.firebaseapp.com",
    messagingSenderId: "283248561390"
  }
};
